import { render, staticRenderFns } from "./GroupEdit.vue?vue&type=template&id=bea79e60&scoped=true"
import script from "./GroupEdit.vue?vue&type=script&lang=js"
export * from "./GroupEdit.vue?vue&type=script&lang=js"
import style0 from "./GroupEdit.vue?vue&type=style&index=0&id=bea79e60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea79e60",
  null
  
)

export default component.exports